module.exports = __webpack_public_path__ + "static/media/step-3-nose-swab.2cd30897.svg";